
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { RegExOnlyText } from '../../../../../../Helper/regEx/RegExOnlyText';
import { AstricSign } from '../../../../../../Helper/AstricSign';
import { WorkNameDDL } from '../../../../../../Components/CommonDDL/WorkNameDDL';
import { DummyDDL } from '../../../../../../Components/CommonDDL/DummyDDL';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';


export default function AddElectricProjectNamePoPUp(props) {

    const { item, EditIcon, Flag, handleIsPost, rowData, open, handleOnCloseClick } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    // const [rowData, setRowData] = useState(Flag === 'Update' ? item : '')

    const [DesignationName, setDesignationName] = useState(Flag === 'Update' ? rowData.designationName : '')

    const [IsPost, setIsPost] = useState(false)

    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

        const [WardName, setWardName] = useState({
            DDL: [],
            ID: '0',
            Label: "Select...",
        })

    const [WorkSubType, setWorkSubType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [WorkName, setWorkName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // useEffect(() => {
    //     setDesignationName(Flag === 'Update' ? rowData.designationName : '')
    // }, [item, IsOpen])

    const handlePost = () => {
        // const data = {
        //     M_DesignationID: Flag === 'Update' ? rowData.id : '0',
        //     DesignationName: DesignationName,
        //     M_UserID: UserID,
        //     token: token,
        //     Flag: Flag === 'Update' ? 'Update' : 'Insert',
        //     handleIsPost: handleIsPost,
        //     handleOnCloseClick: handleOnCloseClick
        // }
        // dispatch(DesignationPostDataAPI({ data }))
    }

    const [IsValidText, setIsValidText] = useState(false)

    const handleCheckText = (e) => {
        setDesignationName(e.target.value)
        const IsValid = RegExOnlyText(e.target.value)
        setIsValidText(IsValid)
        return IsValid
    }

    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">{Flag === "Update" ? "Update":"Add"} Project Name</h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">

                                <div className="col-12">
                                    <div className="form-group">
                                        {/* <WorkNameDDL
                                            WorkName={WorkName}
                                            setWorkName={setWorkName}
                                            WorkType={WorkType}
                                            WorkSubType={WorkSubType}
                                            IsPost=''
                                        /> */}
                                        <WardNameDataDDL
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            HWard='0'
                                            WLable=''
                                            Type="Electrical"
                                            APIFlag="Master"
                                            IsPost={IsPost}
                                        />
                                    </div>
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <DummyDDL
                                            Name="Project Name"
                                        />
                                    </div>
                                </div>

                                

                                {/* <div className="col-12">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Project Name</b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="DesignationName"
                                            // value={DesignationName}                                          
                                            value={DesignationName}
                                            // onChange={(e) => handleCheckText(e)}
                                            onChange={(e) => setDesignationName(e.target.value)}
                                        />
                                    </div>
                                </div> */}


                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => handlePost()}
                                        disabled={
                                            DesignationName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Add"} </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}


        </Popup>
    )

}